import { defineComponent as _defineComponent } from 'vue'
export interface Step {
  label: string;
  status: 'completed' | 'in-progress' | 'pending';
  href?: string;
  isClickable?: boolean;
}

interface Props {
  steps: Step[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressWizard',
  props: {
    steps: null
  },
  setup(__props: any) {



function getStatusText(status: string): string {
  const statusMap: { [key: string]: string } = {
    'completed': 'Completado',
    'in-progress': 'En progreso',
    'pending': 'Pendiente',
  };
  return statusMap[status] || status;
}

return { __sfc: true,getStatusText }
}

})